// ** React Imports
import { useState, createContext } from 'react'

const NotificationContext = createContext()

export default NotificationContext